import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../utils/axios';
import { faPhone, faSearch, faMicrophone, faPhoneSlash, faBan, faCheck } from '@fortawesome/free-solid-svg-icons';
import person from "../assets/images/person.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../assets/css/calllogpage.css';
import { FetchCallLog } from '../redux/apicalling/dispatchfunction';
import { useDispatch, useSelector } from 'react-redux';
import { rtcended } from '../redux/backgroundpermission/permission-action';
function CallLog() {
  const [contacts, setContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [skip, setSkip] = useState(0);
  const [take] = useState(10);
  const [hasMore, setHasMore] = useState(true);
const[show,setshow]=useState(true);
  const backgroundstate = useSelector((state) => state.bgpermission);
  const observer = useRef();
  const [callDates, setCallDates] = useState([]);
  const [audioSrc, setAudioSrc] = useState(null);
  const agent = localStorage.getItem("username");
  const baseurl = 'http://localhost:4444';
  const dispatch = useDispatch();
 const config_api = JSON.parse(localStorage.getItem('config'))
 const numberMask = JSON.parse(localStorage.getItem('number_mask'));

     const userPermission = config_api.projects[0].userPermission;
  const fetchContacts = useCallback(async (skipValue, searchTermValue) => {
    dispatch(FetchCallLog({
      agent: agent,
      skip: skipValue,
      take: take,
      phone_number: searchTermValue,
    })).then((response) => {
      const data = response.data.data;
      
      const formattedDates = data.map((contact) => formatDate(contact.calldate));
      setCallDates((prevCallDates) => [...prevCallDates, ...formattedDates]);

      if (data.length < take) {
        setHasMore(false);
      }

      if (skipValue === 0) {
        setContacts(data);
      } else {
        setContacts((prevContacts) => [...prevContacts, ...data]);
      }
    }).catch((err) => {
      return err
    })

  }, [agent, take]);

  useEffect(() => {
    fetchContacts(0, searchQuery);
  }, [fetchContacts, searchQuery]);

  useEffect(() => {
    if (backgroundstate.rtcended) {
      setshow(false);
    }
  }, [backgroundstate.rtcended]);

  useEffect(() => {
    if (skip > 0) {
      fetchContacts(skip, searchQuery);
    }
  }, [skip, fetchContacts, searchQuery]);

  const lastContactElementRef = useRef();
  const lastContactCallback = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setSkip((prevSkip) => prevSkip + take);
        }
      });
      if (node) observer.current.observe(node);
    },
    [hasMore, take]
  );

  const handleSearch = () => {
    setSkip(0);
    setHasMore(true);
    setSearchQuery(searchTerm);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const leadc2c = (number) => {
    console.log("hariiiiiiii", number);
    let data = { number: number };
    window.postMessage({ type: 'Manual', data: data });
    setshow(false)
  };

  const fetchCallRecording = async (data) => {
    setAudioSrc(null)
    if (data !== '') {
      console.log(data, "444444444444444444444444444444444", data);
      const interval = setInterval(() => {
        setAudioSrc(data)
      }, 1000);


    }

  };
  const fetchTalkTime = async (data) => {
    const talktime = data.map((contact) => fetchTalkTime(contact.talk_time));
    return fetchTalkTime(talktime)
  }
  // const GetStatusIcon = async (contact) => {
  //   const status = GetStatusIcon(contact.status);
  //   return GetStatusIcon(status)
  // }

  const maskPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;
    const maskedNumber = phoneNumber.slice(0, -4).padEnd(phoneNumber.length, 'X');
    return maskedNumber;
  };

  return (
    <div className="App">
      <div className="contact-list">
        {audioSrc && (
          <div className='audiofile'>
            <audio controls autoPlay>
              <source src={audioSrc} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </div>

        )}
        <div className="contact-list-title"></div>
        <div className="search-container">
          <input
            className="calllogsearch"
            type="text"
            placeholder="Search Number"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <FontAwesomeIcon
            icon={faSearch}
            className="search-icon"
            onClick={handleSearch}
          />
        </div>

        {contacts.length === 0 ? (
          <p className="no-data-message">No Data</p>
        ) : (
          <ul className="contact-items">
            {contacts.map((contact, index) => {
              const contactElement = (
                <li key={contact.id} className="contact-item">
                  <img
                    src={person}
                    alt={contact.agent}
                    className="contact-image"
                  />
                  <div className="contact-details-content">
                    <div>
                      <div className='PhoneNumberWrap'>
                        <div className="lead-name">{ numberMask ? maskPhoneNumber(contact.phone_number):contact.phone_number}</div>
                        <div className='PhoneNumberWrap_rht'>

                          {contact.status === "COMPLETE" && <FontAwesomeIcon icon={faCheck} className="faCheck" />}
                          {contact.status === "ABANDON" && <FontAwesomeIcon icon={faBan} className="faBan" />}
                          {contact.status === "NOANSWER" && <FontAwesomeIcon icon={faPhoneSlash} className="faPhoneSlash" />}
                        </div>
                      </div>

                      <div className="pnumber">{callDates[index]}</div>
                    </div>

                    <div>
                      <div className="icons">

                        <FontAwesomeIcon icon={faMicrophone} onClick={() => fetchCallRecording(contact.record_location)} className={contact.record_location === "" ? 'icon-disabled' : 'icon'} />


                        <div className="faPhone">

                          <FontAwesomeIcon icon={faPhone} onClick={() => show && leadc2c(contact.phone_number)} style={{ cursor: show ? 'pointer' : 'not-allowed', opacity: show ? 1 : 0.5 }} />
                        </div>


                        <span className="call-duration">{contact.formatted_talk_time}</span>
                      </div>
                    </div>
                    {/* <div className="call-duration">{leadc2c(contact.duration)}</div> */}
                  </div>

                </li>
              );

              if (contacts.length === index + 1) {
                return <li ref={lastContactCallback} key={contact.id}>{contactElement}</li>;
              } else {
                return contactElement;
              }
            })}
          </ul>
        )}

      </div>

    </div>
  );
}

function formatDate(datestring) {
  const date = new Date(datestring);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default CallLog;